import type { FaireProductEntity } from "../../entity_types/product";

export const p_h58um9xn6f: FaireProductEntity = {
  token: "p_h58um9xn6f",
  type: "product",
  name: "Aloha Hibiscus Letterpress Card",
  brandName: "Cravings Media",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/29f9dbf0062c36a5489a92d614988e4e351366e1b78243fa6687736f2a08a92f.png",
  priceDollars: 3.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/b4a5841d74af7fe95dfbd96c3e839c5fbfd1e013498179266328841340e903bb.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
